const setupFooter = () => {
  let el = document.querySelector('footer.saig-o-footer');

  if (!el) {
    return;
  }

  let labelEls = el.querySelectorAll<HTMLLabelElement>('label[class*=-title]');

  [].forEach.call(labelEls, (label: HTMLInputElement) => {
    label.addEventListener('click', (e) => {
      e.preventDefault();

      let input = label.previousElementSibling as HTMLInputElement;

      if (input) {
        input.checked = !input.checked;
      }
    });
  });
};

setupFooter();
export {};
